<template>
  <div>
    <h3>Attributes:</h3>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="value" label="参数" width="150"> </el-table-column>
      <el-table-column prop="describe" label="说明" width="150"> </el-table-column>
      <el-table-column prop="type" label="类型" width="200"> </el-table-column>
      <el-table-column prop="Option" label="可选值" width="150"> </el-table-column>
      <el-table-column prop="default" label="默认值" width="150"> </el-table-column>
      <el-table-column prop="required" label="必填" width="50"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          value: " linkAddress",
          describe: "链接方式",
          type: "String",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: " internalLinkName",
          describe: "内部链接名称",
          type: "String",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: " linkUrl",
          describe: "链接地址",
          type: "String",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: " accessRulers",
          describe: "访问规则",
          type: "Array",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: " openBlankPage",
          describe: "是否新开页面",
          type: "Boolean",
          Option: "-",
          default: "-",
          required: "true"
        }
      ]
    }
  }
}
</script>

<style></style>
